/* eslint-disable object-shorthand */
import { api } from 'src/boot/axios'

export function loginReq(data) {
  return api({
    url: 'user/webLogin',
    method: 'post',
    mode: 'cors',
    data: {
      Account: data.username,
      Password: data.password,
      DeviceId: 'web',
      Platform: data.platform,
      DeviceName: data.deviceName
    }
  })
}

export function loginRep(data) {
  if (!data) return
  return {
    // data: data,
    email: data.Email,
    token: data.Token,
    type: data.Type,
    uid: data.Uid,
    vipTimeLeft: data.VipTimeLeft,
    whiteList: data.WhiteList
  }
}

export function getUserInfoReq(data) {
  return api({
    url: 'user/info',
    method: 'post',
    headers: {
      DeviceId: data
    },
    data: {}
  })
}
export function getUserInfoRep(data) {
  if (!data) return
  return {
    data: data.data
  }
}

export function registerReq(data) {
  return api({
    url: 'user/register',
    method: 'post',
    data: {
      Account: data.username,
      Password: data.password,
      DeviceId: data.deviceId,
      Platform: data.platform,
      DeviceName: data.deviceName
    }
  })
}

export function registerRep(data) {
  if (!data) return
  return {}
}
